import { createSelector } from 'reselect';
import {
  filterEmergencyCalls,
  filterAniAliCalls,
} from '../../../utils/filterEmergencyCalls';

export const callQueueSelector = createSelector(
  (callQueue, hasAniAliAccess) => {
    return {
      callQueue,
      hasAniAliAccess,
    };
  },
  ({ callQueue, hasAniAliAccess }) => {
    return hasAniAliAccess
      ? filterEmergencyCalls(callQueue)
      : filterAniAliCalls(filterEmergencyCalls(callQueue));
  },
);
